import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-batch',
  template: `
    <main class="page">
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </main>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchComponent {}
